import { isCustomerUser } from '@order-management/roles';
import useUser from './user';

export function useIsCustomerUser() {
  const { user: currentUser } = useUser();

  return isCustomerUser(currentUser);
}

export default useIsCustomerUser;
